export function extractIdFromUrl(url) {
  if (url === null || url === undefined) {
    return null;
  }

  const parts = url.split('/').filter(part => part.trim() !== '');
  return parts.pop() || '';
}
